import { __awaiter, __generator } from "tslib";
import { fetchForbiddenWords } from './fetch-forbidden-words';
/**
 * Validates engraving message
 * @param message Engraving message to validate
 */
export var validateEngravingMessage = function (message) { return __awaiter(void 0, void 0, void 0, function () {
    var isMessageMadeOfWhitespaces, forbiddenWords, escapeWords, forbiddenWordsPattern, asciiPunctuationAndSymbols, digits, latinAlphabet, latinExtended, spacingModifierLetters, greekAlphabet, cyrillic, math, allowedSymbolsPattern;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isMessageMadeOfWhitespaces = !message.replace(/\s/g, '').length && message.length > 0;
                if (isMessageMadeOfWhitespaces) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, fetchForbiddenWords()];
            case 1:
                forbiddenWords = _a.sent();
                escapeWords = forbiddenWords.map(escapeRegex);
                forbiddenWordsPattern = new RegExp("\\b(".concat(escapeWords.join('|'), ")\\b"), 'gi');
                if (message.match(forbiddenWordsPattern)) {
                    return [2 /*return*/, false];
                }
                asciiPunctuationAndSymbols = '!-\/:-@\[-`{-~ ';
                digits = '0-9';
                latinAlphabet = 'A-Za-z';
                latinExtended = '¡-žƒǍǎǺ-ǿȘ-ț';
                spacingModifierLetters = 'ˆˇ˘-˝';
                greekAlphabet = 'ʹ͵;΄-ΊΌΎ-ώϐϑϕ';
                cyrillic = 'Ѐ-џ';
                math = '×÷';
                allowedSymbolsPattern = new RegExp("^[".concat(asciiPunctuationAndSymbols).concat(digits).concat(latinAlphabet).concat(latinExtended)
                    + "".concat(spacingModifierLetters).concat(greekAlphabet).concat(cyrillic).concat(math, "]+$"));
                if (!allowedSymbolsPattern.test(message)) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
        }
    });
}); };
var escapeRegex = function (wordInList) {
    return wordInList.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
